// PRODUCTION — flow editor context provider
import React from 'react'
import { FlowEditorContext } from './useFlowEditorContext'
import { useFlowEditorContextComposer } from './useFlowEditorContextComposer'

export function FlowEditorProvider({ children }: { children: React.ReactNode }) {
  const value = useFlowEditorContextComposer()

  return <FlowEditorContext.Provider value={value}>{children}</FlowEditorContext.Provider>
}
